module.exports = __webpack_public_path__ + "fonts/GlacialIndifference.d2902e1f.woff";